import { render } from "./index.vue?vue&type=template&id=f887dbd4&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=f887dbd4&scoped=true&lang=css"

import exportComponent from "E:\\vueapp\\xm-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f887dbd4"]])

export default __exports__